<template>
    <div ref="bajas">
        <vs-row class="p-4" :loading="loadingStatusBaja">
            <vs-col w="12" class="lineTitulo mb-2">
                <h5><strong>BAJAS Y SUSPENCIONES</strong></h5>
            </vs-col>
            <vs-col w="12">
                <vs-button
                    class="ml-auto"
                    flat
                    @click="activeBaja =! activeBaja"
                >
                    CAMBIAR ESTATUS
                </vs-button>
            </vs-col>
            <template v-if="statusGuardados[0]">
                <vs-col w="12" v-for="(estatus, e) in statusGuardados" :key="e" class=" py-2 px-2">
                    <vs-row class="p-3" style="border:1px solid #E5E7E9; border-radius: 5px; ">
                        <vs-col w="12" class="text-right mb-3">
                            <div class="estatus-alumno mb-2" :class="coloresEstatus(estatus.motivo)">
                                <small><strong>{{estatus.status}}</strong></small>
                            </div>
                        </vs-col>
                        <vs-col sm="12" lg="6" style="border-right: 1px solid #E5E7E9;" class="pr-3">
                            <p class="mb-0"><strong>{{estatus.institucion}}</strong></p>
                            <p><small><i>INSTITUCIÓN</i></small></p>
                            <p class="mb-0"><strong>{{estatus.ciclo_escolar}}</strong></p>
                            <p><small><i>CICLO ESCOLAR</i></small></p>
                            <p class="mb-0"><strong>{{estatus.date}}</strong></p>
                            <p><small><i>FECHA DE ESTATUS MODIFICADO</i></small></p>
                            <div class="d-flex justify-content-between align-items-center" v-if="estatus.bloqueo_boleta_por">
                                <div>
                                    <p class="mb-0"><i class="fas fa-check-circle mr-1"></i> <strong>{{bloqueo[estatus.bloqueo_boleta_por]['text']}}</strong></p>
                                    <p><small><i>MOTIVO DE BLOQUEO DE BOLETA</i></small></p>
                                </div>
                                <div v-if="estatus.cantidad_motivo">
                                    <p class="mb-0"><strong>
                                        <span v-if="estatus.bloqueo_boleta_por == 'cartera_vencida'">{{estatus.cantidad_motivo | currency }}</span>
                                        <span v-else>{{estatus.cantidad_motivo }}</span>
                                        </strong></p>
                                    <p><small><i>CANTIDAD</i></small></p>
                                </div>
                            </div>
                        </vs-col>
                        <vs-col sm="12" lg="6" class="pl-3">
                            <p class="mb-0"><i class="fas fa-user-edit"></i> <strong>{{estatus.user}}</strong></p>
                            <p><small><i>USUARIO QUE MODIFICO EL ESTATUS</i></small></p>
                            <p class="mb-0"><strong>{{estatus.comment}}</strong></p>
                            <p><small><i>COMENTARIO</i></small></p>
                        </vs-col>
                    </vs-row>
                </vs-col>
            </template>
        </vs-row>
    <modal-estatus v-model="activeBaja" :personaRol="personaRol" :general="general" @refreshComponent="getEstatusBajasSuspenciones"></modal-estatus>
    </div>
</template>
<script>
import alumnos from '../../../../../api/requests/alumno'
import ModalEstatus from './modal_estatus.vue'
export default {
    props: [
        'general',
        'personaRol',
        'institucion_id_url',
        'proceso'
    ],
    data(){
        return{
            motivo:'',
            motivos: [
                // {'id': 1, 'text': 'Prospecto'},
                // {'id': 2, 'text': 'Interesado'},
                // {'id': 3, 'text': 'Aplicante'},
                // {'id': 4, 'text': 'Admitido'},
                // {'id': 5, 'text': 'Inscrito económico'},
                // {'id': 6, 'text': 'Congelado'},
                // {'id': 7, 'text': 'Descartado'},
                // {'id': 8, 'text': 'Inscrito académico'},
                // {'id': 9, 'text': 'Acreditado en ciclo escolar'},
                {'id': 10, 'text': 'No acreditado en ciclo escolar'},
                {'id': 11, 'text': 'Baja definitiva voluntaria'},
                {'id': 12, 'text': 'Baja definitiva por conducta'},
                // {'id': 13, 'text': 'Baja temporal voluntaria'},
                {'id': 14, 'text': 'Suspensión por morosidad'},
                {'id': 15, 'text': 'Bloqueo para inscripción'},
                {'id': 16, 'text': 'Reactivación'}
            ],
            estatuId: (new Date()).getTime(),
            comentario: '',
            statusGuardados:[
                // {
                //     "persona_id": 725,
                //     "institucion": 'INSTITUTO MEXICO DE TOLUCA',
                //     "ciclo_escolar": 'Ciclo escolar 2022 - 2023',
                //     "usario": "Gustavo Hernández Valenzuela",
                //     "fecha": "08-12-2022",
                //     "motivo": "Baja definitiva voluntaria",
                //     "comentario": "Baja 28 Octubre",
                //     "bloqueo_boleta_por": "cartera_vencida",
                //     "cantidad_motivo": '2500'
                // },
                // {
                //     "persona_id": 991,
                //     "institucion": 'INSTITUTO MEXICO PRIMARIA (AMORES CDMX)',
                //     "ciclo_escolar": 'Ciclo escolar 2022 - 2023',
                //     "usario": "Jesús Hernández Venegas",
                //     "fecha": "14-02-2023",
                //     "motivo": "Reactivación",
                //     "comentario": "SE REINCORPORA A CLASES",
                //     "bloqueo_boleta_por": "",
                //     "cantidad_motivo": ''
                // }
            ],
            bloqueo: {
                'no_bloquear_boleta': {
                    "text": 'No bloquear boleta'
                },
                'cartera_vencida': {
                    "text": 'Cartera vencida'
                },
                'conceptos_vencidos': {
                    "text": 'Conceptos vencidos'
                },
            },
            activeBaja: false,
            errorFields: [],
            loadingStatusBaja: false
        }
    },
    components:{
        ModalEstatus
    },
    methods: {
        coloresEstatus(estatus){
            const vm = this
            if(estatus == 'Reactivación'){
                return 'col-green'
            }else if(['Suspensión por morosidad', 'No acreditado en ciclo escolar'].includes(estatus)){
                return 'col-yellow'
            }else if(['Baja definitiva voluntaria', 'Baja definitiva por conducta', 'Bloqueo para inscripción'].includes(estatus)){
                return 'col-red'
            }else{
                return 'col-blue'
            }
        },
        async getEstatusBajasSuspenciones(){
            if(this.general.datos.persona_id){
                console.log(this.$refs.bajas)
                const loading = this.$vs.loading({
                    target: this.$refs.bajas
                })
                try{
                    const params = {
                        institucion_id: this.institucion_id_url
                    }
                    const { data: response } = await alumnos.getEstatusBajasSuspenciones(this.general.datos.persona_id, params)

                    this.statusGuardados = response
                    loading.close()
                }catch{

                }
                
            }
        },
        async postBajasSuspenciones(){
            if(!this.estatu){
                this.errorFields.push('estatu')
            }
            else{
                this.errorFields = []
                const loading = this.$vs.loading()
                try{
                    const formaData = new FormData();
                    formaData.append('_method', 'PATCH')
                    formaData.append('estatus', this.estatu)
                    formaData.append('comentario', this.comentario)
                    formaData.append('institicion_id', this.institucion_id_url)
                    const {data: response} = await alumnos.postBajasSuspenciones(this.general.datos.persona_id, formaData)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        icon: '<i class="fas fa-check"></i>',
                        title: 'Operación éxitosa',
                        text: response.message
                    })
                    loading.close()
                    this.estatu = ''
                    this.comentario = ''
                    this.getEstatusBajasSuspenciones()
                    this.$emit('refreshComponent', this.general.datos.persona_id, this.proceso)
                }catch{
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Operación éxitosa',
                        text: response.message
                    })
                }
            }
        },
    },
    watch:{
        general(){
            this.getEstatusBajasSuspenciones()
        }
    }
}
</script>
<style>
.lineTitulo{
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 3%;
}
.inputTitulo label{
    padding-left: 11px;
    margin-top: 2%;
}
.align-items-center{
    align-items: center;
}
</style>
<style lang="scss" scoped>
    .estatus-alumno{
        display:inline-block;
        // background-color: #007BFF;
        // color:#ffff;
        padding: 3px 15px;
        border-radius: 7px;
        text-transform: uppercase;
    }

    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }
</style>
